// extracted by mini-css-extract-plugin
export default {"hideTooltip":"e9-z","fadeIn":"f9-z","delay":"g9-z","recommendedSizeTooltip":"h9-z"};